import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

import { SpinnerFallback } from "@facade/components/ui";
import { isAuthenticated } from "./auth";

interface Props {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: Props) {
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    async function check() {
      const result = await isAuthenticated();

      setAuthenticated(result);
      setLoading(false);
    }

    void check();
  }, []);

  if (loading) {
    return <SpinnerFallback />;
  }

  if (!authenticated) {
    return (
      <Navigate
        to="/signin"
        replace
        state={{
          redirectTo: location.pathname + location.search + location.hash,
        }}
      />
    );
  }

  return children;
}
